<template>
  <div class="mask">
    <!--   <iframe v-if="isusersession==='nosession' || isuseruserinfo==='nosession'" id="pluginonlin" name="pluginonlin"-->
    <!--           :src="`https://tool.5118.com/Pluginonline`"-->
    <!--           style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>-->
    <!--   <iframe v-if="isuseruserinfo=='nosession'" id="pluginonlin" name="pluginonlin"-->
    <!--           :src="`https://tool.5118.com/Pluginonline`"-->
    <!--           style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>-->

    <!-- <iframe v-if="logged" id="onlinetongji" name="onlinetongji"
            :src="`https://aiplugin.5118.com/Pluginstat/?p=UserOnline`"
            style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe> -->
    <div class="card" v-loading="loading">
      <div class="head">
        <div class="title">整句智能原创</div>
        <div class="close" @click="close">×</div>
      </div>
      <div class="body">
        <Loading2 v-if="!logged" :noFlex="true"></Loading2>
        <div style="padding: 5px 0; line-height: 28px;">
          <label
            >源语句：<span v-if="islengthout"
              >(<span style="color: red;">{{ lengthmsg }}</span
              >/100)</span
            ></label
          >
          <br />
          <span class="ormsginfo">
            {{ wycmsg }}
            <span v-if="isoutok" style="background-color: #ebebeb;">
              {{ wycoutmsg }}
              <div style="text-align: right;">
                <span style="color: #ee9a00;">已经超出100个字上限，</span>
                <span
                  @click="jump_msg()"
                  style="color: #166df2; cursor: pointer;"
                  >点击获取完整结果</span
                >
              </div>
            </span>
          </span>
        </div>
        <div
          style="
            border-top: 1px solid #eee;
            margin-bottom: 10px;
            margin-top: 10px;
          "
        >
          <label style="line-height: 35px;">智能原创结果：</label>
          <div v-if="iswycgetcount" class="showjumpbox">
            <p style="text-align: center; line-height: 300px;">
              您已超出最大使用量{{ exportcount }}次，如继续使用智能原创功能，<a
                href="https://wyc.5118.com/"
                target="_blank"
              >
                <span
                  style="
                    color: #2d7dff;
                    font-size: 14px;
                    text-decoration: underline;
                  "
                  >请前往5118获取更多</span
                ></a
              >
            </p>
          </div>
          <div class="group" v-loading="loading1">
            <div class="wycmodel">
              模型1：文风流畅改写<span
                v-if="level < 100 && !upVip"
                style="margin-left: 15px;"
                >试用：20次</span
              >
            </div>
            <textarea class="input" v-if="!upVip" v-model="result1"></textarea>
            <div v-else class="up_vip">
              <div>
                <p>
                  <img src="../../src/assets/image/box_lock.png" width="35" />
                </p>
                <p>
                  您当前用户级别暂不支持该模型改写；升级SVIP即可使用，<a
                    :href="jumpPrice"
                    target="_blank"
                    >去升级</a
                  >
                </p>
              </div>
            </div>
            <button
              class="btn"
              :style="{ padding: btnPadding }"
              @click="copy('result1')"
            >
              <img
                v-if="upVip"
                src="../../src/assets/image/btn_lock.png"
                width="20"
              />
              <pre>{{ submitmsg1 }}</pre>
            </button>
          </div>
          <div class="group" v-loading="loading2">
            <div class="wycmodel">
              模型2：谨慎句式改写<span
                v-if="level < 100 && !upVip"
                style="margin-left: 15px;"
                >试用：20次</span
              >
            </div>
            <textarea class="input" v-if="!upVip" v-model="result2"></textarea>
            <div v-else class="up_vip">
              <div>
                <p>
                  <img src="../../src/assets/image/box_lock.png" width="35" />
                </p>
                <p>
                  您当前用户级别暂不支持该模型改写；升级SVIP即可使用，<a
                    :href="jumpPrice"
                    target="_blank"
                    >去升级</a
                  >
                </p>
              </div>
            </div>
            <button
              class="btn"
              :style="{ padding: btnPadding }"
              @click="copy('result2')"
            >
              <img
                v-if="upVip"
                src="../../src/assets/image/btn_lock.png"
                width="20"
              />
              <pre>{{ submitmsg2 }}</pre>
            </button>
          </div>
          <div class="group" v-loading="loading3">
            <div class="wycmodel">模型3：轻度句式改写</div>
            <textarea class="input" v-model="result3"></textarea>
            <button class="btn" @click="copy('result3')">
              <pre>{{ submitmsg3 }}</pre>
            </button>
          </div>
          <!-- <div class="group" v-loading="loading4">
            <div class="wycmodel">模型4：轻度句式改写</div>
            <textarea class="input"  v-model="result4"></textarea>
            <button class="btn" @click="copy('result4')">
              <pre>{{submitmsg4}}</pre>
            </button>
          </div> -->
          <div style="text-align: right;">
            不满意
            <span @click="jump_msg()" style="color: #166df2; cursor: pointer;"
              >点击获取更优质的结果</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading2 from '../components/global/LoginBox2/Main';
import Cookies from 'js-cookie';
// import axios  from 'axios'
export default {
  data: function () {
    return {
      wycmsg: '',
      wycoutmsg: '',
      allwycmsg: '',
      result1: '',
      result2: '',
      result3: '',
      // result4: "",
      lengthmsg: '',
      loading: false,
      isoutok: false,
      islengthout: false,
      loading1: false,
      loading2: false,
      loading3: false,
      // loading4: false,
      submitmsg1: '复制智\n能原创',
      submitmsg2: '复制智\n能原创',
      submitmsg3: '复制智\n能原创',
      // submitmsg4: "复制智\n能原创",
      count1: -1,
      count2: -1,
      count3: -1,
      // count4:-1,
      version: '2.0.1',
      iswycgetcount: false,
      loginBox: null,
      logged: false,
      isusersession: '',
      isuseruserinfo: '',
      userid: '',
      exportcount: 30,
      tryexportcount: -1,
      upVip: false,
      btnPadding: '0px 5px',
      jumpPrice: 'https://www.5118.com/price',
      ispush: 0,
    };
  },
  components: {
    Loading2,
  },
  watch: {
    tryexportcount: {
      handler(val) {
        if (val === '0') {
          this.upVip = true;
          this.submitmsg1 = '开通SVIP';
          this.submitmsg2 = '开通SVIP';
          this.upVip ? (this.btnPadding = '0px 5px') : (this.btnPadding = '');
        }
      },
    },
  },
  mounted() {
    this.get_user_data();
    this.listen();
  },
  computed: {
    level: {
      get() {
        return this.$store.state.menu.level;
      },
      set(val) {
        this.$store.state.menu.level = val;
      },
    },
    // logged: {
    //   get() {
    //     return this.$store.state.user.logged
    //   }
    // }
  },
  methods: {
    close() {
      this.$messenger.addTarget(window.parent, 'parent');
      this.$messenger.targets['parent'].send('Close-Pseudo-Original-Info');
    },
    listen() {
      let userInfo =
        JSON.parse(Cookies.get('_5118_Plug_In_UserInfo') || '{}') || {};
      this.logged = !!userInfo.avatar;
      this.userid = userInfo.uid || '';
      this.level = userInfo.level || 0;
      this.ispush = Cookies.get('server__push5118') || 0;

      //测试数据
      // this.level=200;
      // this.logged=true;

      //权限判断
      // this.level>=100?this.upVip=false:this.upVip=true;
      this.upVip ? (this.btnPadding = '0px 5px') : (this.btnPadding = '');

      if (this.isusersession != 'nosession')
        this.isuseruserinfo = userInfo.uid || 'nosession';
      this.$messenger.addTarget(window.parent, 'parent');
      this.$messenger.targets['parent'].send(
        'Send-Pseudo-Original-UserID',
        this.userid
      );
      this.$messenger.targets['parent'].send('Send-ACT-IsPush', this.ispush);
      // console.log('开始写入cookie');
      let addtime = new Date().getTime();
      Cookies.set('_5118_Plug_In_Session', addtime, {
        expires: 100000,
        path: '/',
        domain: '.5118.com',
      });

      if (!this.logged) {
        if (this.loginBox) {
          this.loginBox.close();
          this.loginBox = null;
        }

        return;
      }

      this.$wycmessenger.listen('_5118_Pseudo_Original_Msg', (msg) => {
        // _hmt.push(['_trackEvent', 'WYC', 'Check']);
        this.wycmsg = '';
        this.wycoutmsg = '';
        this.allwycmsg = '';
        this.isoutok = false;
        this.islengthout = false;

        this.wycmsg = msg[0]['msg'];
        this.wycoutmsg = msg[0]['outmsg'];
        this.allwycmsg = msg[0]['outmsg'];
        // console.log(this.allwycmsg.length);
        if (this.wycoutmsg.length > 100) {
          this.isoutok = true;
          this.islengthout = true;
          this.wycoutmsg = msg[0]['outmsg'].substring(100, 150);
          this.lengthmsg = msg[0]['outmsg'].length;
        }
        if (this.allwycmsg.length >= 150) {
          this.wycoutmsg = this.wycoutmsg + '......';
        }
        if (!this.upVip) {
          this.result1 = '智能原创数据加载中......';
          this.result2 = '智能原创数据加载中......';
          this.result3 = '智能原创数据加载中......';
          // this.result4 = "智能原创数据加载中......";
          this.submitmsg1 = '复制智\n能原创';
          this.submitmsg2 = '复制智\n能原创';
          this.submitmsg3 = '复制智\n能原创';
          this.submitmsg4 = '复制智\n能原创';
          // this.loading = true;
          this.loading1 = true;
          this.loading2 = true;
          this.loading3 = true;
          this.loading4 = true;
        } else {
          this.result1 = `您当前用户级别暂不支持该模型改写；升级SVIP即可使用，<a href="https://www.5118.com/price" target="_blank">去升级</a>`;
          this.result2 = `您当前用户级别暂不支持该模型改写；升级SVIP即可使用，<a href="https://www.5118.com/price" target="_blank">去升级</a>`;
          this.result3 = '智能原创数据加载中......';
          // this.result4 = "智能原创数据加载中......";
          this.submitmsg1 = '开通SVIP';
          this.submitmsg2 = '开通SVIP';
          this.submitmsg3 = '复制智\n能原创';
          this.submitmsg4 = '复制智\n能原创';
          // this.loading = true;
          this.loading1 = false;
          this.loading2 = false;
          this.loading3 = true;
          this.loading4 = true;
        }
      });
      this.$wycmessenger.listen('_5118__Pseudo_Original_UseCount', (msg) => {
        this.exportcount = msg.count;
        if (msg.type === 1) {
          this.loading1 = false;
          this.tryexportcount = msg.count;
        }
        if (msg.type === 2) {
          this.loading2 = false;
          this.tryexportcount = msg.count;
        }
        if (msg.type === 3) {
          this.loading3 = false;
          this.iswycgetcount = true;
        }
        if (msg.type === 4) {
          this.loading4 = false;
          this.iswycgetcount = true;
        }
      });

      this.$wycmessenger.listen('_5118__Pseudo_Original_Return_Msg', (msg) => {
        if (!this.upVip) {
          if (msg[0]['wyctype'] === 1) {
            this.loading1 = false;
            this.count1 = msg[0]['count'];
            this.result1 = msg[0]['wycmsg'];
          }
          if (msg[0]['wyctype'] === 2) {
            this.loading2 = false;
            this.count2 = msg[0]['count'];
            this.result2 = msg[0]['wycmsg'];
          }
        }
        if (msg[0]['wyctype'] === 3) {
          this.loading3 = false;
          this.count3 = msg[0]['count'];
          this.result3 = msg[0]['wycmsg'];
        }
        // if (msg[0]['wyctype'] === 4) {
        //   this.loading4 = false;
        //   this.count4=msg[0]['count'];
        //   this.result4 = msg[0]['wycmsg']
        // }
      });

      // this.$wycmessenger.listen("_5118_Pseudo_Original_Version_No", (msg) => {
      //   this.version=msg;
      // });
    },
    copy(name) {
      if (name === 'result1' || name === 'result2') {
        if (this.upVip) {
          window.open(this.jumpPrice);
          return;
        }
      }
      let textarea = document.createElement('textarea');
      textarea.value = this[name];
      textarea.style.transform = 'translateY(-9999px)';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('Copy');

      name == 'result1'
        ? (this.submitmsg1 = '复制\n成功')
        : this.upVip
        ? (this.submitmsg1 = '开通SVIP')
        : (this.submitmsg1 = '复制智\n能原创');
      name == 'result2'
        ? (this.submitmsg2 = '复制\n成功')
        : this.upVip
        ? (this.submitmsg2 = '开通SVIP')
        : (this.submitmsg2 = '复制智\n能原创');

      name == 'result3'
        ? (this.submitmsg3 = '复制\n成功')
        : (this.submitmsg3 = '复制智\n能原创');
      // name == "result4" ? this.submitmsg4 = "复制\n成功" : this.submitmsg4 = "复制智\n能原创";

      document.body.removeChild(textarea);
    },
    jump_msg() {
      this.$messenger.addTarget(window.parent, 'parent');
      this.$messenger.targets['parent'].send(
        'Pseudo-Original-Jump-5118-Msg',
        this.allwycmsg
      );
    },
    get_user_data() {
      this.isusersession = Cookies.get('_5118_Plug_In_Session') || 'nosession';
    },
  },
};
</script>

<style>
html,
body {
  background-color: transparent !important;
}
</style>
<style type="text/less" lang="less" scoped>
.mask {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: fade(black, 30);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  &:after {
    content: '';
    display: inline-block;
    height: 100%;
    width: 0;
    vertical-align: middle;
  }
}

.card {
  text-align: left;
  border-radius: 2px;
  background-color: #fff;
  width: 700px;
  position: relative;
  .head {
    position: relative;
    height: 50px;
    line-height: 50px;
    border-bottom: solid 1px #e6e6e6;
    .title {
      margin: 0;
      display: inline-block;
      font-weight: normal;
      text-indent: 15px;
      font-size: 16px;
    }
    .close {
      cursor: pointer;
      font-size: 25px;
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -10px;
      width: 20px;
      height: 20px;
      line-height: 16px;
      text-align: center;
    }
  }
  .body {
    padding: 0 15px;
    font-size: 14px;
    position: relative;
    label {
      display: inline-block;
      // color: #bebebe;
      font-weight: bold;
      font-size: 14px;
    }
    .showjumpbox {
      height: 530px;
      border: 1px solid #dad5d5;
      position: absolute;
      background-color: #fff;
      width: 670px;
      z-index: 100;
    }
    .ormsginfo {
      color: #bebebe;
      font-size: 12.5px;
    }
    .group {
      position: relative;
      margin-bottom: 3px;
      .wycmodel {
        margin-bottom: 5px;
        color: #666;
        font-size: 12px;
      }
      .btn_lock {
        background: url('../../src/assets/image/btn_lock.png') no-repeat 50%;
        vertical-align: top;
        margin-left: 7px;
      }
      .icons {
        display: inline-block;
        height: 25px;
        width: 25px;
      }
      .up_vip {
        font-size: 12px;
        color: #343434;
        width: 88%;
        height: 100px;
        padding: 8px;
        border: solid 1px #e7e7e7;
        border-radius: 2px;
        resize: none;
        overflow: auto;
        display: inline-block;
        line-height: 30px;
        padding-top: 15px;
        text-align: center;
        a {
          color: #0b99ff;
          text-decoration: underline;
        }
      }
      textarea {
        width: 88%;
        height: 100px;
        padding: 8px;
        border: solid 1px #e7e7e7;
        border-radius: 2px;
        resize: none;
        overflow: auto;
      }
      button {
        width: 10%;
        padding: 9px;
        float: right;
        display: inline-block;
        white-space: nowrap;
        cursor: pointer;
        text-align: center;
        outline: none;
        margin: 0;
        transition: 0.1s;
        font-weight: 500;
        font-size: 14px;
        background-color: #166df2;
        border: 1px solid #166df2;
        color: white;
        height: 100px;
        overflow: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Wyc.vue